import { render, staticRenderFns } from "./devInstall.vue?vue&type=template&id=65c2c5d6&scoped=true&"
import script from "./devInstall.vue?vue&type=script&lang=js&"
export * from "./devInstall.vue?vue&type=script&lang=js&"
import style0 from "./devInstall.vue?vue&type=style&index=0&id=65c2c5d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2c5d6",
  null
  
)

export default component.exports